import ServiceCard from './ServiceCard';
import type { ServicesProps } from './useServices';

const ServicesMobile = ({ data, handleServiceClick }: ServicesProps) => {
  return (
    <section
      id="services"
      className="flex flex-col items-center gap-10 bg-surface-primary px-6 py-16"
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <span className="font-body text-xs font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-3xl font-medium text-foreground-primary">
          {data.title}
        </h2>
      </div>

      <div className="flex w-full flex-col gap-6">
        {data.services.map((service) => (
          <ServiceCard
            key={service.id}
            service={service}
            onClick={handleServiceClick}
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesMobile;
